import mock from "../mock"
export let  dataList={
  "count": 25,
  "next": "http://104.248.163.118:8000/dashboard/shops/?page=2",
  "previous": null,
  "results": [
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010529685,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 4,
          "created_at": "2020-10-09T12:12:58.050800Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010276790,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 3,
          "created_at": "2020-10-09T12:22:14.464907Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010575334,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-09T14:37:41.590977Z"
      },
      {
          "title": "Keyboard Shop I❤️",
          "description": "Ggggg yyyyyyyyyyyyyyyyyyuuyyyyyyyyuuuu I will be there at work now but I will",
          "channel": -1000010066308,
          "profile_picture": 131,
          "total_offers": 16,
          "total_products": 26,
          "created_at": "2020-10-09T15:33:13.814867Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010118305,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 3,
          "created_at": "2020-10-10T19:25:04.552021Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010318563,
          "profile_picture": null,
          "total_offers": 4,
          "total_products": 5,
          "created_at": "2020-10-12T12:08:36.623305Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010057006,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 1,
          "created_at": "2020-10-12T14:51:57.116088Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010687577,
          "profile_picture": null,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-13T19:11:49.316796Z"
      },
      {
          "title": "title",
          "description": "descriptiong",
          "channel": -1000010574952,
          "profile_picture": null,
          "total_offers": 1,
          "total_products": 4,
          "created_at": "2020-10-14T19:15:46.402398Z"
      },
      {
          "title": "Hope is awsome",
          "description": "Hope I can make it to the meeting tonight but I will",
          "channel": -1000010695661,
          "profile_picture": 63,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-19T08:05:43.145785Z"
      },
      {
          "title": "80 Movies With DVD",
          "description": "Egg 🥚 is the best egg 🥚🥚😋😋 fright people don't blaeved but for some reason they do what the ucj",
          "channel": -1000010283063,
          "profile_picture": 119,
          "total_offers": 0,
          "total_products": 2,
          "created_at": "2020-10-19T08:33:49.780329Z"
      },
      {
          "title": "Berhan Owner shop",
          "description": "my ciik sgio",
          "channel": -1000010425367,
          "profile_picture": 65,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-19T08:46:46.734629Z"
      },
      {
          "title": "Temperature",
          "description": "Ten and I have to be with me and we can",
          "channel": -1000010125159,
          "profile_picture": 67,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-19T10:54:20.812650Z"
      },
      {
          "title": "Computer Sales",
          "description": "Computer and I am not sure if I can make it to the year you up",
          "channel": -1000010210632,
          "profile_picture": 68,
          "total_offers": 0,
          "total_products": 1,
          "created_at": "2020-10-19T12:46:01.007796Z"
      },
      {
          "title": "ddd",
          "description": "this shop is awsome",
          "channel": -1000010129156,
          "profile_picture": 76,
          "total_offers": 0,
          "total_products": 0,
          "created_at": "2020-10-20T20:45:15.962348Z"
      }
  ]
}

const determinePopularity = val => {
  if (val >= 75) return { popValue: val, color: "success" }
  else if (val < 75 && val >= 55) return { popValue: val, color: "primary" }
  else if (val < 55 && val >= 35) return { popValue: val, color: "warning" }
  else if (val < 35 && val >= 0) return { popValue: val, color: "danger" }
  else return { popValue: 0, color: "danger" }
}

// GET DATA
mock.onGet("/api/datalist/initial-data").reply(response => {
  return [200, dataList]
})

mock.onGet("/api/datalist/data").reply(response => {
  let { page, perPage } = response
  let totalPages = Math.ceil(dataList.results.length / perPage)
  if (page !== undefined && perPage !== undefined) {
    let calculatedPage = (page - 1) * perPage
    let calculatedPerPage = page * perPage
    return [
      200,
      { data: dataList.results.slice(calculatedPage, calculatedPerPage), totalPages }
    ]
  } else {
    return [
      200,
      { data: dataList.results.slice(0, 4), totalPages: Math.ceil(dataList.length / 4) }
    ]
  }
})

// UPDATE DATA
mock.onPost("/api/datalist/update-data").reply(request => {
  let data = JSON.parse(request.data).obj
  dataList.map(item => {
    if (item.id === data.id) {
      let popularity = determinePopularity(data.popularity.popValue)
      return Object.assign(item, { ...data, popularity })
    } else {
      return item
    }
  })
  return [200]
})

// Add DATA
mock.onPost("/api/datalist/add-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let highestId = Math.max.apply(
    Math,
    dataList.map(i => i.id)
  )
  dataList.unshift({
    ...data,
    id: highestId + 1,
    popularity: determinePopularity(data.popularity.popValue)
  })
  return [200]
})

// DELETE DATA
mock.onPost("/api/datalist/delete-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let index = dataList.findIndex(item => item.id === data.id)
  dataList.splice(index, 1)
  return [200]
})

// DELETE SELECTED DATA
mock.onPost("/api/datalist/delete-selected").reply(request => {
  let data = JSON.parse(request.data).arr
  let reducedArray
  ;[dataList, data].reduce((a, b) => {
    let c = b.map(j => j.id)
    return (reducedArray = a.filter(i => !c.includes(i.id)))
  })
  dataList = reducedArray
  return [200]
})
